import axios from "axios";
import { baseUrl } from "./dwcommonutils";
import { storeJwt } from "./localstorage/jwtStorage";
import { loadRefreshToken, storeRefreshToken } from "./localstorage/jwtStorage";
const apiVersion = process.env.API_VERSION || "1.0";
let ongoingRefresh = null;
export async function requestAuthTokenRefresh() {
    const sourceRefreshToken = loadRefreshToken();
    if (!sourceRefreshToken)
        return { status: "no_token" };
    if (ongoingRefresh?.sourceRefreshToken === sourceRefreshToken) {
        return ongoingRefresh.promise;
    }
    const promise = (async () => {
        try {
            const url = `${baseUrl}/api/${apiVersion}/auth/refresh`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${sourceRefreshToken}`,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                },
                timeout: 10000,
            });
            const newAuthToken = response.data?.authToken;
            if (newAuthToken) {
                return {
                    status: "success",
                    authToken: newAuthToken,
                    refreshToken: response.data?.refreshToken,
                    sourceRefreshToken,
                };
            }
            return { status: "unavailable", httpStatus: response.status, sourceRefreshToken };
        }
        catch (error) {
            const status = error?.response?.status;
            if (status === 401 || status === 403) {
                return { status: "rejected", httpStatus: status, sourceRefreshToken };
            }
            return { status: "unavailable", httpStatus: status, sourceRefreshToken };
        }
    })();
    ongoingRefresh = { sourceRefreshToken, promise };
    const result = await promise;
    if (ongoingRefresh?.promise === promise)
        ongoingRefresh = null;
    return result;
}
export async function validateSavedAuthToken(authToken) {
    if (!authToken)
        return { status: "no_token" };
    try {
        const response = await axios.get(`${baseUrl}/api/${apiVersion}/users/profile`, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Cache-Control": "no-cache, no-store, must-revalidate",
                Pragma: "no-cache",
            },
            responseType: "blob",
            timeout: 10000,
        });
        if (response.status >= 200 && response.status < 300) {
            return { status: "success", authToken, sourceAuthToken: authToken };
        }
        return { status: "unavailable", httpStatus: response.status, sourceAuthToken: authToken };
    }
    catch (error) {
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
            return { status: "rejected", httpStatus: status, sourceAuthToken: authToken };
        }
        return { status: "unavailable", httpStatus: status, sourceAuthToken: authToken };
    }
}
export async function refreshAuthToken() {
    const result = await requestAuthTokenRefresh();
    if (result.status !== "success" || loadRefreshToken() !== result.sourceRefreshToken) {
        return null;
    }
    await storeJwt(result.authToken);
    if (result.refreshToken)
        storeRefreshToken(result.refreshToken);
    return result.authToken;
}
